module.exports = __webpack_public_path__ + "img/icono.30242705.png";